import StaffHeader from "@/components/StaffHeader";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import GuardianOverviewTab from "@/components/admin/guardian/GuardianOverviewTab";
import GuardianFailedPaymentsTab from "@/components/admin/guardian/GuardianFailedPaymentsTab";
import GuardianDonorsTab from "@/components/admin/guardian/GuardianDonorsTab";
import GuardianDonationsTab from "@/components/admin/guardian/GuardianDonationsTab";

export default function GuardianDashboard() {
  return (
    <div className="min-h-screen bg-amtm-bg" data-testid="guardian-dashboard-page">
      <StaffHeader />
      <div className="max-w-5xl mx-auto px-4 py-6 pb-24">
        <h1 className="font-display text-3xl text-amtm-text mb-6" data-testid="guardian-dashboard-title">Guardians</h1>

        <Tabs defaultValue="overview">
          <TabsList data-testid="guardian-dashboard-tabs">
            <TabsTrigger value="overview" data-testid="guardian-tab-overview">Overview</TabsTrigger>
            <TabsTrigger value="failed" data-testid="guardian-tab-failed">Failed Payments</TabsTrigger>
            <TabsTrigger value="donors" data-testid="guardian-tab-donors">Donors</TabsTrigger>
            <TabsTrigger value="donations" data-testid="guardian-tab-donations">Donations</TabsTrigger>
          </TabsList>
          <TabsContent value="overview" className="mt-5"><GuardianOverviewTab /></TabsContent>
          <TabsContent value="failed" className="mt-5"><GuardianFailedPaymentsTab /></TabsContent>
          <TabsContent value="donors" className="mt-5"><GuardianDonorsTab /></TabsContent>
          <TabsContent value="donations" className="mt-5"><GuardianDonationsTab /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
